import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { align: "center" }
const _hoisted_2 = { style: {"margin-top":"16px","display":"flex","flex-direction":"row","gap":"90px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_time_picker = _resolveComponent("v-time-picker")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { flat: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "d-flex align-center pe-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { icon: "mdi-form-select" }),
          _cache[3] || (_cache[3] = _createTextVNode("   Slots Management ")),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            disabled: _ctx.loading,
            loading: _ctx.loading,
            class: "text-none mb-4",
            color: "secondary",
            size: "large",
            variant: "flat",
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode(" Save ")
            ])),
            _: 1
          }, 8, ["disabled", "loading", "onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.allSlotsSettings.timeZoneLabel), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    align: "start",
                    justify: "center",
                    class: "border-thin"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "2" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(day[0].toUpperCase() + day.slice(1).toLowerCase()), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_v_col, { cols: "8" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_v_list, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allSlotsSettings[day], (slot, slotIndex) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, { key: slotIndex }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, {
                                        class: "pa-2",
                                        align: "center",
                                        justify: "center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            sm: "5"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_text_field, {
                                                modelValue: slot.timeStart,
                                                "onUpdate:modelValue": ($event: any) => ((slot.timeStart) = $event),
                                                active: slot.startMenu,
                                                focus: slot.startMenu,
                                                label: "Start",
                                                variant: "outlined",
                                                placeholder: "10:00",
                                                readonly: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_menu, {
                                                    modelValue: slot.startMenu,
                                                    "onUpdate:modelValue": ($event: any) => ((slot.startMenu) = $event),
                                                    "close-on-content-click": false,
                                                    activator: "parent",
                                                    transition: "scale-transition"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (slot.startMenu)
                                                        ? (_openBlock(), _createBlock(_component_v_time_picker, {
                                                            key: 0,
                                                            max: slot.endTime,
                                                            modelValue: slot.timeStart,
                                                            "onUpdate:modelValue": ($event: any) => ((slot.timeStart) = $event),
                                                            format: "24hr",
                                                            "full-width": "",
                                                            color: "secondary"
                                                          }, {
                                                            actions: _withCtx(() => [
                                                              _createElementVNode("div", _hoisted_2, [
                                                                _createVNode(_component_v_btn, {
                                                                  color: "secondary",
                                                                  onClick: ($event: any) => (_ctx.removeSlot(day, slotIndex))
                                                                }, {
                                                                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                                                                    _createTextVNode("Cancel")
                                                                  ])),
                                                                  _: 2
                                                                }, 1032, ["onClick"]),
                                                                _createVNode(_component_v_btn, {
                                                                  color: "secondary",
                                                                  onClick: ($event: any) => (slot.startMenu = false)
                                                                }, {
                                                                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                                    _createTextVNode("Create")
                                                                  ])),
                                                                  _: 2
                                                                }, 1032, ["onClick"])
                                                              ])
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["max", "modelValue", "onUpdate:modelValue"]))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["modelValue", "onUpdate:modelValue"])
                                                ]),
                                                _: 2
                                              }, 1032, ["modelValue", "onUpdate:modelValue", "active", "focus"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            sm: "5"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_select, {
                                                label: "Time",
                                                "item-value": "duration",
                                                "item-title": "label",
                                                items: _ctx.durations,
                                                modelValue: slot.duration,
                                                "onUpdate:modelValue": ($event: any) => ((slot.duration) = $event),
                                                width: "120"
                                              }, null, 8, ["items", "modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_col, {
                                            cols: "12",
                                            sm: "2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_btn, {
                                                icon: "mdi-delete",
                                                variant: "dense",
                                                onClick: ($event: any) => (_ctx.confirmRemoveSlot(day, slotIndex))
                                              }, null, 8, ["onClick"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_v_col, { cols: "1" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            icon: "mdi-plus",
                            dense: "",
                            flat: "",
                            onClick: ($event: any) => (_ctx.addSlot(day))
                          }, null, 8, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider, { vertical: "" }),
          _createVNode(_component_v_col, {
            cols: "6",
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_date_picker, {
                multiple: "",
                modelValue: this.allSlotsSettings.exceptions,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.allSlotsSettings.exceptions) = $event)),
                title: "Select exceptions",
                min: new Date()
              }, null, 8, ["modelValue", "min"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.allSlotsSettings.exceptions, (d, i) => {
                return (_openBlock(), _createBlock(_component_v_chip, {
                  class: "ma-2",
                  key: d,
                  closable: "",
                  "onClick:close": ($event: any) => (_ctx.removeExceptionDay(i))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(d.toDateString()), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick:close"]))
              }), 128)),
              _createVNode(_component_v_autocomplete, {
                class: "ml-4 mt-8",
                label: "TimeZone",
                "item-value": "value",
                "item-title": "text",
                items: _ctx.timeZones,
                modelValue: this.allSlotsSettings.timeZone,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.allSlotsSettings.timeZone) = $event)),
                variant: "outlined"
              }, null, 8, ["items", "modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}